module.exports = {"411224001":"兴贤里街道","411224100":"城关镇","411224101":"杜关镇","411224102":"五里川镇","411224103":"官道口镇","411224104":"朱阳关镇","411224105":"官坡镇","411224106":"范里镇","411224107":"东明镇","411224108":"双龙湾镇","411224200":"文峪乡","411224201":"横涧乡","411224203":"双槐树乡","411224204":"汤河乡","411224205":"瓦窑沟乡","411224206":"狮子坪乡","411224207":"沙河乡","411224208":"徐家湾乡","411224209":"潘河乡","411224210":"木桐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411224.json
// module id = 1756
// module chunks = 0